'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _adminOnRest = require('admin-on-rest');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, parsedApolloQueryResult) {
    var type = _ref.type,
        payload = _ref.payload,
        _ref$meta = _ref.meta,
        restType = _ref$meta.fetch,
        meta = (0, _objectWithoutProperties3.default)(_ref$meta, ['fetch']);
    return {
        type: type + '_SUCCESS',
        payload: parsedApolloQueryResult,
        requestPayload: payload,
        meta: (0, _extends3.default)({}, meta, { fetchResponse: restType, fetchStatus: _adminOnRest.FETCH_END })
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/realtime/buildAorAction.js
// module id = 940
// module chunks = 0